const getQuestionForm = (question: number) => {
  switch (question) {
    case 1: return 'ent_ol_tipo_servicio_buscado_recomendador';
    case 2: return 'ent_ol_usuarios_simultaneos_recomendador';
    case 3: return 'ent_ol_cantidad_ejecutivos_telefono_recomendador';
    case 4: return 'ent_ol_numero_mueva_contigo_recomendador';
    case 5: 
    case 6: return 'ent_ol_actividades_realizadas_recomendador';
    default: return undefined;
  }
}

const getCookieByName = (name: string) => {
  const value: string = "; " + document.cookie;
  const parts: Array<string> = value.split("; " + name + "=");
  if (parts.length === 2) {
    return parts?.pop()?.split(";").shift();
  }
}

export const parseAnswersDataHubspot = (email:string, answers: Array<any>, servicesRecommended: Array<any>, selectedService: String = "", phone: String) => {
  let fields: Array<any> = [];
  fields.push({"name": "email", "value": email});
  fields.push({"name": "phone", "value": phone})
  for (let i = 0; i < answers.length; i++) {
    const questionName = getQuestionForm(answers[i].id_question);
    if (questionName) {
      fields.push({
        "name": questionName,
        "value": (typeof(answers[i].alternative_text) === 'string') ? answers[i].alternative_text : answers[i].alternative_text.join(';')
      });
    }
  }

  fields.push({"name": "ent_ol_servicios_recomendados_recomendador", "value": servicesRecommended.join(';')});
  //fields.push({"name": "ent_ol_servicio_escogido_recomendador", "value": selectedService});
  const data: any = {
    "fields": fields,
      "context": {
      "hutk": getCookieByName("hubspotutk"),
      "pageUri": "https://www.entel.cl/empresas/",
      "pageName": "Recomendador"
    }
  }
  return data;
}